import { connect } from "react-redux";
import { selectXpInfo } from "../../selectors/selectXpInfo";
import { HOCHudComponent } from "../context-menu/HOCHudComponent";
import { componentFromType } from "../generic/componentFromType";
import { IdTooltipAnchor, withDynamicTooltip } from "../tooltip";
import { XpBar } from "./XpBar";
import { XpTooltip } from "./XpTooltip";
export var HudXp = connect(selectXpInfo)(HOCHudComponent(withDynamicTooltip({
    adjustHorizontal: -14,
    anchor: IdTooltipAnchor.Top,
    component: componentFromType(XpTooltip),
})(XpBar)));



//////////////////
// WEBPACK FOOTER
// ./src/features/xp/HudXp.tsx
// module id = 884
// module chunks = 3